<template>
  <div
    class="wrapper"
    v-loading.fullscreen.lock="loading"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="wp-body">
      <div class="page__card">
        <div class="page__card-title">
          <button
            class="bg-indigo-400 p-1 w-8 h-8 mr-2 rounded-xl"
            @click="$router.go(-1)"
          >
            <i class="el-icon-arrow-left"></i>
          </button>
          <h1>{{ $t("transport_facility_info") }}</h1>
        </div>
        <el-form :model="form" :rules="rules" ref="form">
          <div class="flex flex-col gap-5">
            <div class="p-4 rounded-2xl bg-cool-50 flex flex-col gap-5">
              <div>
                <div class="flex items-center gap-2">
                  <IconBuilding4 class="w-6 h-6 text-cyan-600" />
                  <h1 class="text-xl leading-snug font-bold">
                    {{ $t("all_datas") }}
                  </h1>
                </div>
              </div>
              <div class="-m-1.5 flex flex-wrap">
                <!-- Шифри - Transport facility code/cipher -->
                <el-form-item
                  :label="$t('shifr')"
                  prop="shifr"
                  class="p-1.5 mb-0 w-full sm:w-1/2 md:w-1/3 lg:w-1/4"
                  :rules="rule"
                >
                  <el-input
                    v-model="form.shifr"
                    class=""
                    :placeholder="$t('shifr')"
                    :disabled="disabled"
                    clearable
                  />
                </el-form-item>
                <!-- Тури - Type -->
                <el-form-item
                  :label="$t('type')"
                  prop="type_transport_facility"
                  class="p-1.5 mb-0 w-full sm:w-1/2 md:w-1/3 lg:w-1/4"
                  :rules="rule"
                >
                  <el-select
                    v-model="form.type_transport_facility"
                    class="w-full"
                    :placeholder="$t('type')"
                    :disabled="disabled"
                    clearable
                  >
                    <el-option
                      v-for="item in dictionary.type_transport_facility"
                      :key="item.id"
                      :label="item[`name_${$i18n.locale}`] || item.name_cyr"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
                <!-- Қурилиш йили - Construction year -->
                <el-form-item
                  :label="$t('year_construction')"
                  prop="year_construction"
                  class="p-1.5 mb-0 w-full sm:w-1/2 md:w-1/3 lg:w-1/4"
                  :rules="rule"
                >
                  <el-date-picker
                    v-model="form.year_construction"
                    style="width: 100%"
                    :placeholder="$t('year_construction')"
                    :disabled="disabled"
                    type="year"
                    value-format="yyyy"
                    format="yyyy"
                  />
                </el-form-item>
                <!-- Жойлашган йўлнинг тоифаси - Road category -->
                <el-form-item
                  :label="$t('road_category')"
                  prop="road_category"
                  class="p-1.5 mb-0 w-full sm:w-1/2 lg:w-1/4"
                  :rules="rule"
                >
                  <el-select
                    v-model="form.road_category"
                    class="w-full"
                    :placeholder="$t('road_category')"
                    :disabled="disabled"
                    clearable
                  >
                    <el-option
                      v-for="item in dictionary.road_category"
                      :key="item.id"
                      :label="item[`name_${$i18n.locale}`] || item.name_cyr"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
                <!-- Кесиб ўтувчи тўсиқ тури - Barrier type -->
                <el-form-item
                  :label="$t('barrier_type')"
                  prop="barrier.barrier_type"
                  class="p-1.5 mb-0"
                  :class="
                    form.barrier.barrier_type == 1
                      ? 'w-full sm:w-1/2 lg:w-1/3'
                      : 'w-full sm:w-1/2'
                  "
                  :rules="rule"
                >
                  <el-select
                    v-model="form.barrier.barrier_type"
                    class="w-full"
                    :placeholder="$t('barrier_type')"
                    :disabled="disabled"
                    clearable
                  >
                    <el-option
                      v-for="item in dictionary.barrier_type"
                      :key="item.id"
                      :label="item[`name_${$i18n.locale}`] || item.name_cyr"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
                <!-- Сув хавзаси тури - Water basin type -->
                <el-form-item
                  v-if="form.barrier.barrier_type == 1"
                  :label="$t('water_basin_type')"
                  prop="barrier.water_basin"
                  class="p-1.5 mb-0 w-full sm:w-1/2 lg:w-1/3"
                  :rules="rule"
                >
                  <el-select
                    v-model="form.barrier.water_basin"
                    class="w-full"
                    :placeholder="$t('water_basin_type')"
                    :disabled="disabled"
                    clearable
                  >
                    <el-option
                      v-for="item in dictionary.water_basin"
                      :key="item.id"
                      :label="item[`name_${$i18n.locale}`] || item.name_cyr"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
                <!-- Кесиб ўтувчи тўсиқ номи - Barrier name -->
                <el-form-item
                  :label="$t('barrier_name')"
                  prop="barrier.barrier_name"
                  class="p-1.5 mb-0"
                  :class="
                    form.barrier.barrier_type == 1
                      ? 'w-full sm:w-1/2 lg:w-1/3'
                      : 'w-full sm:w-1/2'
                  "
                  :rules="rule"
                >
                  <el-input
                    v-model="form.barrier.barrier_name"
                    class=""
                    :placeholder="$t('barrier_name')"
                    :disabled="disabled"
                    clearable
                  />
                </el-form-item>
                <!-- Вилоят - Region -->
                <el-form-item
                  :label="$t('region')"
                  prop="region"
                  class="p-1.5 mb-0 w-full sm:w-1/2 lg:w-1/3"
                  :rules="rule"
                >
                  <el-select
                    v-model="form.region"
                    class="w-full"
                    :placeholder="$t('region')"
                    :disabled="disabled"
                    clearable
                    filterable
                    @change="form.district = ''"
                  >
                    <el-option
                      v-for="item in dictionary.region"
                      :key="item.id"
                      :label="item[`name_${$i18n.locale}`] || item.name_cyr"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
                <!-- Туман - District -->
                <el-form-item
                  :label="$t('district')"
                  prop="district"
                  class="p-1.5 mb-0 w-full sm:w-1/2 lg:w-1/3"
                  :rules="rule"
                >
                  <el-select
                    v-model="form.district"
                    class="w-full"
                    :placeholder="$t('district')"
                    :disabled="disabled"
                    clearable
                  >
                    <el-option
                      v-for="item in dictionary.district.filter(
                        (d) => d.region === form.region
                      )"
                      :key="item.id"
                      :label="item[`name_${$i18n.locale}`] || item.name_cyr"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
                <!-- Геолокацияси координатлари - Geolocation coordinates -->
                <el-form-item
                  :label="$t('geolocation')"
                  prop="geolocation"
                  class="p-1.5 mb-0 w-full sm:w-1/2 lg:w-1/3"
                  :rules="rule"
                >
                  <div class="flex gap-2 w-full">
                    <el-input
                      v-model="form.geolocation"
                      class="flex-1"
                      :placeholder="$t('geolocation')"
                      disabled
                    />
                    <button
                      type="button"
                      class="w-10 h-10 rounded-xl flex items-center justify-center"
                      :class="
                        disabled
                          ? 'bg-indigo-50 hover:bg-indigo-100 text-indigo-800'
                          : 'bg-indigo-800 hover:bg-indigo-700 text-white'
                      "
                      @click="openMap()"
                    >
                      <HEye v-show="disabled" />
                      <HEdit v-show="!disabled" />
                    </button>
                  </div>
                </el-form-item>
                <!-- Йўл рақами - Road number -->
                <el-form-item
                  :label="$t('road_number')"
                  prop="road_name"
                  class="p-1.5 mb-0 w-full sm:w-1/2 xl:w-1/4"
                  :rules="rule"
                >
                  <el-select
                    v-model="form.road_name"
                    class="w-full"
                    :placeholder="$t('road_number')"
                    :disabled="disabled"
                    clearable
                    filterable
                    remote
                    :remote-method="getRoadNames"
                    :loading="road_names.loading"
                    @change="getRoadNameOptions"
                  >
                    <el-option
                      v-for="item in road_names.data"
                      :key="item.id"
                      :label="item.number"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
                <!-- Йўл номи - Road name -->
                <el-form-item
                  :label="$t('road_name')"
                  prop="road_name"
                  class="p-1.5 mb-0 w-full sm:w-1/2 xl:w-1/4"
                  :rules="rule"
                >
                  <el-select
                    v-model="form.road_name"
                    class="w-full"
                    :placeholder="$t('road_name')"
                    :disabled="disabled"
                    clearable
                    filterable
                    :loading="road_names.loading"
                    @change="getRoadNameOptions"
                  >
                    <el-option
                      v-for="item in road_names.data"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
                <!-- Йўл номи тоифаси - Road name category -->
                <el-form-item
                  :label="$t('road_name_option')"
                  prop="road_name_option"
                  class="p-1.5 mb-0 w-full sm:w-1/2 xl:w-1/4"
                >
                  <el-select
                    v-model="form.road_name_option"
                    class="w-full"
                    :placeholder="$t('road_name_option')"
                    :disabled="disabled"
                    clearable
                    filterable
                    multiple
                    :loading="road_name_options.loading"
                  >
                    <el-option
                      v-for="item in road_name_options.data"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
                <!-- Кесиб ўтиш нуқтаси (км) - Crossing point (km) -->
                <el-form-item
                  :label="$t('transport_km')"
                  prop="km"
                  class="p-1.5 mb-0 w-full sm:w-1/2 xl:w-1/4"
                  :rules="rule"
                >
                  <el-input
                    v-model="form.km"
                    class=""
                    :placeholder="$t('transport_km')"
                    :disabled="disabled"
                    clearable
                    type="number"
                  />
                </el-form-item>
              </div>
            </div>
            <div class="p-4 rounded-2xl bg-cool-50 flex flex-col gap-5">
              <div>
                <div class="flex items-center gap-2">
                  <HConnection class="w-6 h-6 text-cyan-600" />
                  <h1 class="text-xl leading-snug font-bold">
                    {{ $t("contact_infos") }}
                  </h1>
                </div>
              </div>
              <div class="-m-1.5 flex flex-wrap">
                <!-- Телефон - Phone -->
                <el-form-item
                  :label="$t('phone')"
                  prop="phone"
                  class="p-1.5 mb-0 w-full sm:w-1/2 md:w-1/3"
                >
                  <el-input
                    v-model="form.phone"
                    v-mask="'+998 (##) ###-##-##'"
                    class=""
                    :placeholder="$t('phone')"
                    :disabled="disabled"
                    clearable
                  >
                  </el-input>
                </el-form-item>
                <!-- Электрон почта манзили - Email address -->
                <el-form-item
                  :label="$t('user_email')"
                  prop="email"
                  class="p-1.5 mb-0 w-full sm:w-1/2 md:w-1/3"
                >
                  <el-input
                    v-model="form.email"
                    class=""
                    :placeholder="$t('user_email')"
                    :disabled="disabled"
                    clearable
                  />
                </el-form-item>
                <!-- Веб-сайт - Website -->
                <el-form-item
                  :label="$t('web_site')"
                  prop="website"
                  class="p-1.5 mb-0 w-full md:w-1/3"
                >
                  <el-input
                    v-model="form.website"
                    class=""
                    :placeholder="$t('web_site')"
                    :disabled="disabled"
                    clearable
                  />
                </el-form-item>
              </div>
            </div>
            <div class="p-4 rounded-2xl bg-cool-50 flex flex-col gap-5">
              <div>
                <div class="flex items-center gap-2">
                  <HCompass class="w-6 h-6 text-cyan-600" />
                  <h1 class="text-xl leading-snug font-bold">
                    {{ $t("technical_information") }}
                  </h1>
                </div>
              </div>
              <div class="-m-1.5 flex flex-wrap">
                <!-- Тротуарлари кенглиги - Sidewalk width -->
                <el-form-item
                  :label="$t('transport_width_sidewalks')"
                  prop="size_of_building.width_of_sidewalks"
                  class="p-1.5 mb-0 w-full sm:w-1/2 md:w-1/3 xl:w-1/4"
                  :rules="rule"
                >
                  <el-input
                    v-model="form.size_of_building.width_of_sidewalks"
                    class=""
                    :placeholder="$t('transport_width_sidewalks')"
                    :disabled="disabled"
                    clearable
                    type="number"
                  />
                </el-form-item>
                <!-- Таъмирланганлиги - Repair type -->
                <el-form-item
                  :label="$t('repaired_type')"
                  prop="repaired.repaired_type"
                  class="p-1.5 mb-0 w-full  sm:w-1/2 md:w-1/3 xl:w-1/4"
                  :rules="rule"
                >
                  <el-select
                    v-model="form.repaired.repaired_type"
                    class="w-full"
                    :placeholder="$t('repaired_type')"
                    :disabled="disabled"
                    clearable
                  >
                    <el-option
                      v-for="item in dictionary.repaired_type"
                      :key="item.id"
                      :label="item[`${$i18n.locale}`] || item.name_cyr"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>

                <!-- Таянчининг материали - Support material -->
                <el-form-item
                  :label="$t('material_support')"
                  prop="material_of_support"
                  class="p-1.5 mb-0 w-full sm:w-1/2 md:w-1/3 xl:w-1/4"
                  :rules="rule"
                >
                  <el-select
                    v-model="form.material_of_support"
                    class="w-full"
                    :placeholder="$t('material_support')"
                    :disabled="disabled"
                    clearable
                  >
                    <el-option
                      v-for="item in dictionary.material_of_support"
                      :key="item.id"
                      :label="item[`${$i18n.locale}`] || item.name_cyr"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
                <!-- Таянч қисми материали - Base material -->
                <el-form-item
                  :label="$t('transport_base_material')"
                  prop="base_material"
                  class="p-1.5 mb-0 w-full sm:w-1/2 lg:w-1/3 xl:w-1/4"
                  :rules="rule"
                >
                  <el-select
                    v-model="form.base_material"
                    class="w-full"
                    :placeholder="$t('transport_base_material')"
                    :disabled="disabled"
                    clearable
                  >
                    <el-option
                      v-for="item in dictionary.base_material"
                      :key="item.id"
                      :label="item[`${$i18n.locale}`] || item.name_cyr"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
                <!-- Статик схемаси бўйича тури - Type by static schema -->
                <el-form-item
                  :label="$t('type_static_schema')"
                  prop="type_static_schema"
                  class="p-1.5 mb-0 w-full sm:w-1/2 lg:w-1/3 2xl:w-1/4"
                  :rules="rule"
                >
                  <el-input
                    v-model="form.type_static_schema"
                    class=""
                    :placeholder="$t('type_static_schema')"
                    :disabled="disabled"
                    clearable
                  >
                  </el-input>
                </el-form-item>
                <!-- Ҳаракат қисми кенглиги - Traffic section width -->
                <el-form-item
                  :label="$t('transport_action_part')"
                  prop="size_of_building.traffic_section"
                  class="p-1.5 mb-0 w-full sm:w-1/2 lg:w-1/3 2xl:w-1/4"
                  :rules="rule"
                >
                  <el-input
                    v-model="form.size_of_building.traffic_section"
                    class=""
                    :placeholder="$t('transport_action_part')"
                    :disabled="disabled"
                    clearable
                    type="number"
                  />
                </el-form-item>
                <!-- Оралиқ қурилмалари сони - Number of intermediate devices -->
                <el-form-item
                  :label="$t('transport_number_intermediate_devices')"
                  prop="structure_scheme.numbers"
                  class="p-1.5 mb-0 w-full sm:w-1/2 lg:w-1/3 2xl:w-1/4"
                  :rules="rule"
                >
                  <el-input
                    v-model="form.structure_scheme.numbers"
                    class=""
                    :placeholder="$t('transport_number_intermediate_devices')"
                    :disabled="disabled"
                    clearable
                    type="number"
                  />
                </el-form-item>
                <!-- Узунлиги бўйича тури - Type by length -->
                <el-form-item
                  :label="$t('type_by_length')"
                  prop="type_by_length"
                  class="p-1.5 mb-0 w-full  sm:w-1/2 md:w-1/3 lg:w-1/4"
                  :rules="rule"
                >
                  <el-select
                    v-model="form.type_by_length"
                    class="w-full"
                    :placeholder="$t('type_by_length')"
                    :disabled="disabled"
                    clearable
                  >
                    <el-option
                      v-for="item in dictionary.type_by_length"
                      :key="item.id"
                      :label="item[`name_${$i18n.locale}`] || item.name_cyr"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
                <!-- Таъмирланган йили - Repair year -->
                <el-form-item
                  :label="$t('repair_year')"
                  prop="repaired.year"
                  class="p-1.5 mb-0 w-full sm:w-1/2 md:w-1/3 lg:w-1/4 2xl:w-1/6"
                  :rules="rule"
                >
                  <el-date-picker
                    v-model="form.repaired.year"
                    style="width: 100%"
                    :placeholder="$t('repair_year')"
                    :disabled="disabled"
                    type="year"
                    value-format="yyyy"
                  />
                </el-form-item>

                <!-- Узунлиги - Length -->
                <el-form-item
                  :label="$t('transport_length')"
                  prop="structure_scheme.length"
                  class="p-1.5 mb-0 w-full  sm:w-1/2 md:w-1/3 lg:w-1/2 lg:flex-1 xl:flex-none xl:w-28 2xl:w-1/6"
                  :rules="rule"
                >
                  <el-input
                    v-model="form.structure_scheme.length"
                    class=""
                    :placeholder="$t('transport_length')"
                    :disabled="disabled"
                    clearable
                    type="number"
                  />
                </el-form-item>
                <!-- Оралиқ қурилмасининг материали - Intermediate device material -->
                <el-form-item
                  :label="$t('intermediate_device_material')"
                  prop="intermediate_device_material"
                  class="p-1.5 mb-0 w-full md:w-1/2 lg:flex-1 2xl:flex-none 2xl:w-1/3"
                  :rules="rule"
                >
                  <el-select
                    v-model="form.intermediate_device_material"
                    class="w-full"
                    :placeholder="$t('intermediate_device_material')"
                    :disabled="disabled"
                    clearable
                  >
                    <el-option
                      v-for="item in dictionary.intermediate_device_material"
                      :key="item.id"
                      :label="item[`${$i18n.locale}`] || item.name_cyr"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
                <!-- Қурилиш майдонининг сейсмиклиги - Construction site seismicity -->
                <el-form-item
                  :label="$t('transport_seismicity_construction_site')"
                  prop="seismicity"
                  class="p-1.5 mb-0 w-full md:w-1/2 lg:w-1/2 2xl:w-1/3"
                  :rules="rule"
                >
                  <el-select
                    v-model="form.seismicity"
                    class="w-full"
                    :placeholder="$t('transport_seismicity_construction_site')"
                    :disabled="disabled"
                    clearable
                  >
                    <el-option
                      v-for="item in dictionary.buildingseismicity"
                      :key="item.id"
                      :label="item.number"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
                <!-- Йўл тоифаси талабларига жавоб бериши - Meet road category requirements -->
                <el-form-item
                  :label="$t('transport_meet_requirements')"
                  prop="size_of_building.meet_the_requirements"
                  class="p-1.5 mb-0 w-full md:w-1/2 lg:w-1/2 2xl:w-1/3"
                  :rules="rule"
                >
                  <el-select
                    v-model="form.size_of_building.meet_the_requirements"
                    class="w-full"
                    :placeholder="$t('transport_meet_requirements')"
                    :disabled="disabled"
                    clearable
                  >
                    <el-option
                      v-for="item in dictionary.meet_requirements"
                      :key="item.id"
                      :label="item[`${$i18n.locale}`] || item.name_cyr"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>

                <!-- Антисейсмик тиргаклар мавжудлиги - Anti-seismic struts availability -->
                <el-form-item
                  :label="$t('transport_anti_seismic_struts')"
                  prop="anti_seismic_struts"
                  class="p-1.5 mb-0 w-full md:w-1/2 lg:w-1/2 2xl:w-1/3"
                  :rules="rule"
                >
                  <el-select
                    v-model="form.anti_seismic_struts"
                    class="w-full"
                    :placeholder="$t('transport_anti_seismic_struts')"
                    :disabled="disabled"
                    clearable
                  >
                    <el-option
                      v-for="item in dictionary.anti_seismic_struts"
                      :key="item.id"
                      :label="item[`name_${$i18n.locale}`] || item.name_cyr"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
                <!-- Таянчлари ёки асоси ҳолати ўзгарганлиги - Condition of supports or base change -->
                <el-form-item
                  :label="$t('condition_of_supports')"
                  prop="condition_of_supports"
                  class="p-1.5 mb-0 w-full md:w-1/2 lg:w-1/2 2xl:w-1/3"
                  :rules="rule"
                >
                  <el-select
                    v-model="form.condition_of_supports"
                    class="w-full"
                    :placeholder="$t('condition_of_supports')"
                    :disabled="disabled"
                    clearable
                  >
                    <el-option
                      v-for="item in dictionary.condition_of_supports"
                      :key="item.id"
                      :label="item[`name_${$i18n.locale}`] || item.name_cyr"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>

                <!-- Паспорт тўлдирилаётган кундаги асосий юк кўтарувчи конструкцияларининг техник ҳолати - Technical condition of main load-bearing structures -->
                <el-form-item
                  :label="$t('technical_condition')"
                  prop="technical_condition"
                  class="p-1.5 mb-0 w-full 2xl:w-2/3"
                  :rules="rule"
                >
                  <el-select
                    v-model="form.technical_condition"
                    class="w-full"
                    :placeholder="$t('technical_condition')"
                    :disabled="disabled"
                    clearable
                  >
                    <el-option
                      v-for="item in dictionary.technical_condition"
                      :key="item.id"
                      :label="item[`name_${$i18n.locale}`] || item.name_cyr"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
                <div class="w-full"></div>
                <div class="p-1.5 w-full lg:w-1/2">
                  <div class="bg-white rounded-20 p-4 h-full">
                    <!-- Паспорт ва диагностика ҳужжатлари - Passport and diagnosis documents -->
                    <el-form-item
                      :label="$t('passport_and_diagnosis')"
                      prop="passport_and_diagnosis"
                      class="mb-0"
                    >
                      <ui-upload
                        v-model="form.passport_and_diagnosis"
                        :disabled="disabled"
                        name="passport_and_diagnosis"
                        deleteUrl="/passport_and_diagnosis/"
                        accept=".pdf"
                        :multiple="true"
                        :limit="5"
                        :min="1"
                        @change="validateField('passport_and_diagnosis')"
                      />
                    </el-form-item>
                  </div>
                </div>
                <div class="p-1.5 w-full lg:w-1/2">
                  <div class="bg-white rounded-20 p-4 h-full">
                    <!-- Умумий ҳолати бўйича расмлар - General condition photos -->
                    <el-form-item
                      :label="$t('general_photos')"
                      prop="general_photos"
                      class="mb-0"
                    >
                      <ui-upload
                        v-model="form.general_photos"
                        :disabled="disabled"
                        name="general_photos"
                        deleteUrl="/general_photos/"
                        accept="image/*"
                        :multiple="true"
                        :limit="10"
                        :min="4"
                        @change="validateField('general_photos')"
                      />
                    </el-form-item>
                  </div>
                </div>
                <div class="p-1.5 w-full lg:w-1/2">
                  <div class="bg-white rounded-20 p-4 h-full">
                    <!-- Шикастланиш мавжуд бўлган жойлар - Areas where damage exists -->
                    <el-form-item
                      :label="$t('areas_where_damage')"
                      prop="areas_where_damage"
                      class="mb-0"
                    >
                      <ui-upload
                        v-model="form.areas_where_damage"
                        :disabled="disabled"
                        name="areas_where_damage"
                        deleteUrl="/areas_where_damage/"
                        accept="image/*"
                        :multiple="true"
                        :limit="10"
                        :min="4"
                        @change="validateField('areas_where_damage')"
                      />
                    </el-form-item>
                  </div>
                </div>
                <div class="p-1.5 w-full lg:w-1/2">
                  <div class="bg-white rounded-20 p-4 h-full">
                    <!-- Кучайтириш ва мустаҳкамлаш ишлари ўтказилганлиги тўғрисида маълумот - Information about strengthening and reinforcement works -->
                    <el-form-item
                      :label="$t('strengthening_works_images')"
                      prop="strengthening_works_images"
                      class="mb-0"
                      :rules="rule"
                    >
                      <ui-upload
                        v-model="form.strengthening_works_images"
                        :disabled="disabled"
                        :min="1"
                        name="strengthening_works_images"
                        deleteUrl="/strengthening_works_images/"
                        @change="validateField('strengthening_works_images')"
                      />
                    </el-form-item>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-form>
        <div class="mt-5 flex gap-2 justify-end">
          <button
            v-if="!disabled"
            class="light-button h-10"
            type="button"
            @click="close"
          >
            {{ $t("close") }}
          </button>
          <button
            v-if="!disabled"
            class="add__button"
            type="button"
            @click="Save()"
          >
            {{ $t("save") }} <HCheckCircle />
          </button>
          <button
            v-if="!isNaN($route.params.id) && disabled && role !== 'supervisor' && role !== 'admin'"
            class="px-4 py-2 flex items-center gap-2 rounded-xl bg-indigo-800 text-white"
            type="button"
            @click="$router.push(`/transport/${$route.params.id}?edit`)"
          >
            {{ $t("change") }} <HEdit />
          </button>
        </div>
      </div>
    </div>

    <div v-if="modal" class="modal fs-14" :class="modal ? 'active' : ''">
      <div class="modal-cover"></div>
      <div class="modal-item padding-map" style="width: 95%; height: 95%">
        <div class="flex justify-between modal-absolute-header">
          <p class="modal-title">
            {{ disabled ? `${$t("show_coor")}:` : `${$t("change_coor")}:` }}
          </p>
          <button style="font-size: 16px" @click="modal = false">
            <i class="el-icon-close" style="font-weight: 600"></i>
          </button>
        </div>
        <div class="w-full map-item h-full relative">
          <yandex-map
            @click="clicked"
            :coords="coords"
            style="height: 100%; width: 100%"
            :zoom="14"
            :controls="['zoomControl']"
          >
            <ymap-marker
              :coords="coords"
              marker-id="123"
              hint-content="some hint"
            />
            <button
              v-if="!disabled"
              @click="findMe"
              class="absolute z-10 bottom-8 right-2 bg-white h-10 w-10 rounded-xl flex items-center justify-center"
              style="box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2)"
              type="button"
            >
              <IconLocation />
            </button>
          </yandex-map>
        </div>
        <div class="flex w-full justify-between modal-bottom fw-w">
          <div class="flex items-center modal-inputes">
            <p class="flex items-senter" style="font-size: 16px">
              <b class="mr-2">{{ $t("coor") }}:</b> {{ coords.join() }}
            </p>
          </div>
          <div class="flex items-center justify-center">
            <button @click="modal = false" class="light-button h-10">
              {{ $t("close") }}
            </button>
            <button
              v-if="!disabled"
              class="ml-2 add__button"
              @click="SaveEditMap()"
            >
              {{ $t("save") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HCall from "@/components/Icons/hCall.vue";
import HCheckCircle from "@/components/Icons/hCheckCircle.vue";
import HCompass from "@/components/Icons/hCompass.vue";
import HConnection from "@/components/Icons/hConnection.vue";
import HEdit from "@/components/Icons/hEdit.vue";
import HEye from "@/components/Icons/hEye.vue";
import IconBuilding4 from "@/components/Icons/iconBuilding4.vue";
import IconLocation from "@/components/Icons/iconLocation.vue";
import UiUpload from "@/components/ui/Upload.vue";

export default {
  name: "TransportForm",
  components: {
    HCall,
    HCompass,
    HConnection,
    HEdit,
    HEye,
    IconBuilding4,
    UiUpload,
    HCheckCircle,
    IconLocation,
  },
  data() {
    return {
      loading: false,
      modal: false,
      coords: [41.31629324503914, 69.26717199864542],
      zoom: 14,
      data: {},
      form: {
        shifr: "",
        type_transport_facility: undefined,
        year_construction: null,
        road_category: undefined,
        barrier: {
          barrier_type: undefined,
          water_basin: undefined,
          barrier_name: "",
        },
        region: "",
        district: "",
        geolocation: "",
        road_name: undefined,
        road_name_option: [],
        km: "",

        phone: "",
        email: "",
        website: "",

        type_static_schema: "",
        type_by_length: "",
        seismicity: "",
        intermediate_device_material: "",
        size_of_building: {
          traffic_section: "",
          width_of_sidewalks: "",
          meet_the_requirements: "",
        },
        material_of_support: "",
        base_material: "",
        repaired: {
          year: "",
          repaired_type: "",
        },
        technical_condition: "",
        condition_of_supports: "",
        anti_seismic_struts: "",

        structure_scheme: {
          length: "",
          numbers: "",
        },
        passport_and_diagnosis: [],
        general_photos: [],
        areas_where_damage: [],
        strengthening_works_images: [],
      },
      rule: {
        required: true,
        message: " ",
        trigger: ["blur", "change"],
      },
      rules: {
        barrier: {
          water_basin: [
            {
              required: function (form) {
                return form.barrier.barrier_type == 1;
              },
              message: " ",
              trigger: "blur",
            },
          ],
        },
        phone: [
          {
            required: true,
            message: " ",
            trigger: "blur",
          },
          { min: 19, message: " ", trigger: "blur" },
        ],
        email: [
          {
            type: "email",
            message: " ",
            trigger: ["blur", "change"],
          },
        ],
        passport_and_diagnosis: [
          {
            required: true,
            message: " ",
            trigger: "blur",
          },
          {
            type: "array",
            min: 1,
            message: " ",
            trigger: "change",
          },
        ],
        general_photos: [
          {
            required: true,
            message: " ",
            trigger: "blur",
          },
          {
            type: "array",
            min: 4,
            message: "Файллар сони 4 та дан кам бўлиши мумкин эмас",
            trigger: "change",
          },
        ],
        areas_where_damage: [
          {
            required: true,
            message: " ",
            trigger: "blur",
          },
          {
            type: "array",
            min: 4,
            message: "Файллар сони 4 та дан кам бўлиши мумкин эмас",
            trigger: "change",
          },
        ],
      },
      road_names: {
        loading: false,
        data: [],
      },
      road_name_options: {
        loading: false,
        data: [],
      },
    };
  },
  computed: {
    disabled() {
      return (
        this.role !== "tf_operator" ||
        (!isNaN(this.$route.params.id) && !("edit" in this.$route.query))
      );
    },
    dictionary() {
      return this.$store.state.dictionary;
    },
    role() {
      return this.$store.state.role;
    },
  },
  mounted() {
    if (!isNaN(this.$route.params.id)) {
      this.getData(this.$route.params.id);
    }
  },
  methods: {
    openMap() {
      this.modal = true;
      this.coords =
        this.form.geolocation && this.form.geolocation.split(",").length === 2
          ? this.form.geolocation.split(",").map(Number)
          : [41.31629324503914, 69.26717199864542];
    },
    SaveEditMap() {
      this.modal = false;
      this.form.geolocation = this.coords.join(",");
    },
    clicked(e) {
      if (!this.disabled) {
        this.coords = e.get("coords");
      }
    },
    close() {
      if (isNaN(this.$route.params.id)) {
        this.$router.push("/transport");
      } else {
        this.$router.push(`/transport/${this.$route.params.id}`);
      }
    },
    getRoadNames(search) {
      if (search !== "" && !this.road_names.loading) {
        this.road_names.loading = true;
        axios
          .get("/dictionary/road_name/", {
            params: {
              search,
            },
          })
          .then((res) => {
            this.road_names.data = res.data || [];
          })
          .finally(() => {
            this.road_names.loading = false;
          });
      }
    },
    getRoadName(id) {
      this.road_names.loading = true;
      axios
        .get(`/dictionary/road_name/${id}/`)
        .then((res) => {
          this.road_names.data = [res.data];
        })
        .finally(() => {
          this.road_names.loading = false;
        });
    },
    getRoadNameOptions(road_name) {
      if (road_name) {
        this.road_name_options.loading = true;
        axios
          .get("/dictionary/road_name_option/", {
            params: {
              road_name,
            },
          })
          .then((res) => {
            this.road_name_options.data = res.data.results || [];
          })
          .finally(() => {
            this.road_name_options.loading = false;
          });
      } else {
        this.road_name_options.data = [];
      }
    },

    findMe() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          this.coords = [position.coords.latitude, position.coords.longitude];
          this.zoom = 14;
        });
      }
    },
    validateField(fieldName) {
      this.$nextTick(() => {
        this.$refs.form.validateField(fieldName);
      });
    },
    Save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!isNaN(this.$route.params.id)) {
            this.patchData();
          } else {
            this.postData();
          }
        } else {
          return false;
        }
      });
    },
    getData(id) {
      this.loading = true;
      axios
        .get(`/transport_facility/${id}/`)
        .then((res) => {
          this.data = res.data;
          Object.keys(this.form).forEach((key) => {
            this.form[key] = res.data[key];
          });
          this.form.year_construction = "" + res.data.year_construction;
          this.form.repaired.year = "" + res.data.repaired.year;
          this.form.geolocation = res.data.geolocation.join(",");
          this.getRoadNameOptions(this.form.road_name);
          this.getRoadName(this.form.road_name);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    patchData() {
      this.loading = true;
      let formData = new FormData();
      Object.keys(this.form).forEach((key) => {
        if (
          [
            "passport_and_diagnosis",
            "general_photos",
            "areas_where_damage",
            "strengthening_works_images",
          ].includes(key)
        ) {
          this.form[key].forEach((file, index) => {
            if (!file.id) {
              formData.append(`${key}[${index}]file`, file.file);
            }
          });
        } else if (
          [
            "barrier",
            "size_of_building",
            "repaired",
            "structure_scheme",
          ].includes(key)
        ) {
          Object.keys(this.form[key]).forEach((subKey) => {
            formData.append(`${key}.${subKey}`, this.form[key][subKey]);
          });
        } else {
          formData.append(key, this.form[key]);
        }
      });

      axios
        .patch(`/transport_facility/${this.$route.params.id}/`, formData)
        .then(() => {
          this.$router.push("/transport");
          this.$message.success(this.$t("success_message_patch"));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    postData() {
      this.loading = true;
      let formData = new FormData();
      Object.keys(this.form).forEach((key) => {
        if (
          [
            "passport_and_diagnosis",
            "general_photos",
            "areas_where_damage",
            "strengthening_works_images",
          ].includes(key)
        ) {
          this.form[key].forEach((file, index) => {
            formData.append(`${key}[${index}]file`, file.file);
          });
        } else if (
          [
            "barrier",
            "size_of_building",
            "repaired",
            "structure_scheme",
          ].includes(key)
        ) {
          Object.keys(this.form[key]).forEach((subKey) => {
            formData.append(`${key}.${subKey}`, this.form[key][subKey]);
          });
        } else {
          formData.append(key, this.form[key]);
        }
      });

      axios
        .post("/transport_facility/", formData)
        .then(() => {
          this.$router.push("/transport");
          this.$message.success(this.$t("success_message_post"));
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
